<ng-template #quarterPickerContent>
  <rms-quarter-picker-date
          [yearsList]="yearsList"
          [initialValue]="initialValue"
          (yearSelected)="onYearSelected($event)"
          (onQuarterSelected)="quarterSelected($event)">
  </rms-quarter-picker-date>
  <div class="text-right mt-4">
    <button class="btn btn-default" (click)="resetDateRange(true); p.close()">{{"GENERICS.CANCEL" | translate}}</button>
    <button class="btn btn-teal" [disabled]="invalidDateRange" (click)="setDateRange(); p.close()">{{"GENERICS.OK" | translate}}</button>
  </div>
</ng-template>
<div class="fake-input wtf" [ngbPopover]="quarterPickerContent" [placement]="position ? position : 'bottom'" [autoClose]="false" #p="ngbPopover">
  <span class="placeholder" *ngIf="isEmpty">{{placeholder | translate}}</span>
  <i class="fa fa-calendar field-icon" *ngIf="isEmpty"></i>
  <span *ngIf="!isEmpty">{{startDate[0] + displayValueYear}}aa</span>
</div>

